import { useState, useEffect } from "react";
import "./style.css";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Cart from "./pages/Cart";
import CategoriesPage from "./pages/CategoriesPage";
import CategoryProducts from "./pages/CategoryProducts";
import About from "./pages/About";
import ProductDetails from "./pages/ProductDetails";
import Contact from "./pages/Contact";
import TestimonialsPage from "./pages/TestimonialsPage";
import Wishlist from "./pages/Wishlist";
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import Checkout from "./pages/Checkout";
import ScrollTop from "./ScrollToTop";

function App() {
  const [wishlist, setWishlist] = useState([]);
  const [cart, setCart] = useState([]);

  // ✅ استرجاع البيانات من localStorage عند أول تحميل
  useEffect(() => {
    const savedWishlist = localStorage.getItem("wishlist");
    const savedCart = localStorage.getItem("cart");

    if (savedWishlist) setWishlist(JSON.parse(savedWishlist));
    if (savedCart) setCart(JSON.parse(savedCart));
  }, []);

  // ✅ حفظ أي تحديث في localStorage
  useEffect(() => {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // ❤️ إضافة منتج للمفضلة
  const handleAddToWishlist = (product) => {
    setWishlist((prev) => {
      if (!prev.find((item) => item.id === product.id)) {
        return [...prev, product];
      }
      return prev;
    });
  };

  // 💔 حذف منتج من المفضلة
  const handleRemoveFromWishlist = (id) => {
    setWishlist((prev) => prev.filter((item) => item.id !== id));
  };

  // 🛒 إضافة منتج للسلة (بدون شرط "already in cart")
  const handleAddToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        // لو المنتج موجود نزود الكمية
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        // منتج جديد
        return [...prev, { ...product, quantity: 1 }];
      }
    });
  };

  return (
    <Router>
      {/* ✅ Navbar يظهر عدد المفضلات وعدد الكارت */}
      <Navbar wishlistCount={wishlist.length} cartCount={cart.length} />

      {/* 🔝 زر العودة للأعلى */}
      <ScrollTop
        smooth
        style={{ backgroundColor: "#FF9B1B", borderRadius: "50%" }}
      />

      {/* 🧭 المسارات */}
      <Routes>
        <Route
          path="/"
          element={
            <Home
              wishlist={wishlist}
              onAddToWishlist={handleAddToWishlist}
              onRemoveFromWishlist={handleRemoveFromWishlist}
              onAddToCart={handleAddToCart}
            />
          }
        />

        <Route
          path="/products"
          element={
            <Products
              wishlist={wishlist}
              onAddToWishlist={handleAddToWishlist}
              onRemoveFromWishlist={handleRemoveFromWishlist}
              onAddToCart={handleAddToCart}
            />
          }
        />

        <Route path="/cart" element={<Cart cart={cart} />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/categories/:id" element={<CategoryProducts />} />

        <Route
          path="/product/:id"
          element={
            <ProductDetails
              wishlist={wishlist}
              onAddToWishlist={handleAddToWishlist}
              onRemoveFromWishlist={handleRemoveFromWishlist}
              onAddToCart={handleAddToCart}
            />
          }
        />

        <Route path="/contact" element={<Contact />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />

        <Route
          path="/wishlist"
          element={
            <Wishlist
              wishlist={wishlist}
              onRemoveFromWishlist={handleRemoveFromWishlist}
            />
          }
        />
      </Routes>

      {/* ✅ الفوتر */}
      <Footer />
    </Router>
  );
}

export default App;
